abstract class Path {
	static parse(src : Path.TPathRaw) : Path.TPath {
		let isRelative = false;
		if (src[ 0 ] === '@') {
			src = src.slice(1);
			isRelative = true;
		}
		let ascendsCount = 0;
		while (src[ 0 ] === '@') {
			src = src.slice(1);
			ascendsCount++;
		}
		let firstIsInner = false;
		if (src[ 0 ] === ':') {
			firstIsInner = true;
			src = src.slice(1);
		}
		const path : Path.IPathNode[] = (
			src.split(':').
			map((x, i) => ((i !== 0) || firstIsInner) ? ':' + x : x).
			map(x => x.split('.')).
			flat().
			filter(x => x).
			map(x => ({
				id :       (x[ 0 ] === ':') ? x.slice(1) : x,
				location : (x[ 0 ] === ':') ? 'inner' : 'outer'
			}))
		);
		if (isRelative) {
			return new Path.RelativePath(path, ascendsCount);

		} else {
			return new Path.AbsolutePath(path);
		}
	};

	readonly abstract type : string;
	readonly path : Path.IPathNode[];

	/**
	 * Create a relative path from the current starting at startIndex.
	 */
	slice(startIndex : number) {
		return new Path.RelativePath(
			this.path.slice(startIndex),
			0
		);
	};

	isEqualTo(RHS : Path) {
		const LHS = this;
		if (LHS.type !== RHS.type) {
			return false;
		}
		if (LHS.path.length !== RHS.path.length) {
			return false;
		}
		return LHS.path.every((LHS_x, xi) => {
			const RHS_x = <Path.IPathNode>RHS.path[ xi ];
			return (
				(LHS_x.location !== RHS_x.location) ? false : (
					(RHS_x.id === '**') ? true : (LHS_x.id === RHS_x.id)
				)
			);
		});
	}

	constructor(path : Path.IPathNode[]) {
		this.path = path;
	};
};
namespace Path {
	export interface IPathNode {
		id : Component.TId;
		location : 'inner' | 'outer';
	};

	export class AbsolutePath extends Path {
		override readonly type = 'absolute';
	};

	export class RelativePath extends Path {
		override readonly type = 'relative';
		readonly ascendsCount : number;

		constructor(path : Path.IPathNode[], ascendsCount : number) {
			super(path);
			this.ascendsCount = ascendsCount;
		};
	};
	export type TPath = AbsolutePath | RelativePath;
	export type TPathRaw = string;

}
export default Path;
import Component from './Component';
